import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { API_URL, setAdminAuth } from '../utils/api';

const Login = ({ onLogin, onNavigate }) => {
  const { print_lang } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        setAdminAuth(data.token, data.admin);
        onLogin(data.admin);
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <h1 className="auth-logo-title">Admin Portal</h1>
          <p className="auth-logo-subtitle">Dental Clinic Management</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">{print_lang('auth.email', 'Email')}</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@example.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">{print_lang('auth.password', 'Password')}</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="********"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? print_lang('common.loading', 'Loading...') : print_lang('auth.login', 'Login')}
          </button>
        </form>

        <div className="auth-links">
          <p>
            <a href="#forgot" onClick={(e) => { e.preventDefault(); onNavigate('forgot-password'); }}>
              {print_lang('auth.forgotPassword', 'Forgot Password?')}
            </a>
          </p>
          <p style={{ marginTop: '0.5rem' }}>
            {print_lang('auth.noAccount', "Don't have an account?")}{' '}
            <a href="#signup" onClick={(e) => { e.preventDefault(); onNavigate('signup'); }}>
              {print_lang('auth.signup', 'Sign Up')}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
